import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { formatISODate } from '@/utils/date';
import { SortableHeader, TruncatedCell } from '@/components';
import { ProviderNoteRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';

export const createProviderNotesColumns =
  (): ColumnDef<ProviderNoteRecord>[] => [
    {
      accessorKey: 'providerName',
      header: 'Name',
      cell: ({ row }) => (
        <TruncatedCell
          text={row.original.providerName || 'No data available'}
        />
      ),
    },
    {
      accessorKey: 'facilityType',
      header: 'Facility Type',
      cell: ({ row }) => {
        const label =
          row.original.facilityType ?? row.original.alternateTypeName;
        return label ? <TruncatedCell text={label} /> : 'No data available';
      },
    },
    {
      id: 'dateOfServiceStart',
      accessorKey: 'dateOfServiceStart',
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Date of Service</SortableHeader>
      ),
      cell: ({ row }) => formatISODate(row.original.dateOfServiceStart),
    },
    {
      accessorKey: 'comments',
      header: 'Comments',
      cell: ({ row }) =>
        row.original.comments ? (
          <TruncatedCell text={row.original.comments} />
        ) : (
          'No data available'
        ),
    },
    {
      id: 'dateUploaded',
      accessorFn: (row) => row.createdAt,
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Date Uploaded</SortableHeader>
      ),
      cell: ({ row }) =>
        row.original.createdAt
          ? format(new Date(row.original.createdAt), 'MM/dd/yyyy')
          : 'No data available',
    },
    {
      accessorKey: 'sourceType',
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Source Type</SortableHeader>
      ),
      cell: ({ row }) => row.original.sourceType || 'No data available',
    },
    {
      id: 'actions',
      enableSorting: false,
      header: '',
      cell: ({ row }) => (
        <div className="flex items-center justify-end gap-1">
          <PatientDocumentViewButton
            disabled={!row.original.sourceType}
            documentKey={{
              source: DocumentSource.MEDICAL_RECORDS,
              type: DocumentType.PROVIDER_NOTES,
              providerNoteId: row.original.id,
              sourceType: row.original.sourceType,
              name: row.original.facilityType ?? row.original.alternateTypeName,
            }}
          />
        </div>
      ),
    },
  ];
